import gameKit from '../../GameKit';
import { blokSettings } from '../../GameKit/shared';
import DropdownItemEnum from '../components/SideBar/BlokEditor/BlokEditorDropDownItemEnum';

const defaultState = {
    blokId: null,
    openDropdownItem: DropdownItemEnum.APPEARANCE,
    ...blokSettings,
    history: ['wall', 'metaal', 'rocks', 'houten_krat']
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'BLOK_EDITOR_OPEN': {
            return {
                ...state,
                open: true,
                blokId: action.payload
            };
        }
        case 'BLOK_EDITOR_CLOSE': {
            gameKit.levelEditor.blokEditor.setSelectedBlokByUUID(null, false);
            return {
                ...state,
                open: false,
                blokId: null
            };
        }
        case 'BLOK_EDITOR_SET_STATE': {
            return {
                ...state,
                stateIndex: action.payload
            };
        }
        case 'BLOK_EDITOR_UPDATE_HISTORY': {
            let { history } = state;

            if (action.payload) {
                const value = action.payload;
                if (!history.includes(value)) {
                    history = [value, ...state.history.slice(0, 3)];
                } else {
                    history = history.filter(h => h !== value);
                    history = [value, ...history];
                }
            }

            return { ...state, history };
        }
        case 'BLOK_EDITOR_UPDATE_STATE_LOOK': {
            return {
                ...state,
                data: { ...action.payload }
            };
        }
        case 'BLOK_EDITOR_UPDATE_SETTINGS': {
            return {
                ...state,
                ...action.payload
            };
        }
        case 'SET_OPEN_BLOK_EDITOR_DROPDOWN_ITEM': {
            return {
                ...state,
                openDropdownItem: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
